import * as React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import { MdPlayArrow } from "react-icons/md";

// Presentation/UI
import Navigation from "../../Components/FrontendNav";

// Theme
import { Images } from "../../Themes";

// Utils
import { VIDEO_TUTORIALS_LINK } from "../../Utils/Consts";

const Heading = styled.h1`
  font-weight: 700;
  position: relative;
  top: 105px;
  font-size: 5.15em;
  @media (max-width: 800px) {
    top: 0px;
    font-size: 2.95em;
  }
`;

const SubHeading = styled.p`
  font-weight: 100;
  position: relative;
  top: 105px;
  font-size: 1.35em;
  & .btn {
    width: 180px;
  }
  @media (max-width: 800px) {
    top: 0px;
    font-size: 1.25em;
    & .btn {
      width: 100%;
      margin-top: 20px;
    }
  }
`;

const MainBannerContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  min-height: 700px;
  & .main-banner-illustration {
    position: relative;
    top: 65px;
    height: 450px;
  }
  @media (max-width: 800px) {
    & .main-banner-illustration {
      top: 0px;
      left: -40px;
      height: auto;
      width: 400px;
    }
  }
`;

const Container = styled.div`
  width: calc(100% - 85px);
  margin: 0 auto;
  @media (max-width: 800px) {
    width: calc(100% - 35px);
  }
`;

const MainBanner: React.SFC<{}> = () => {
  return (
    <MainBannerContainer>
      <Navigation />
      <Row>
        <Col xs={12} md={6} lg={6}>
          <Container>
            <Heading>
              Maintenance
              <br />
              management, <br />
              made easy.
            </Heading>
            <br />
            <br />
            <SubHeading>
              Maintain CMMS software makes technicians more agile
              <br /> and maintenance teams more productive.
              <br />
              <br />
              <br />
              <a href={VIDEO_TUTORIALS_LINK} target="_blank">
                <Button className="secondary-btn landing-page-banner-btn">
                  <MdPlayArrow size="1.5em" />
                  &nbsp;&nbsp;See it in action
                </Button>
              </a>
              <Link to="/sign-up">
                <Button>Sign Up For Free</Button>
              </Link>
            </SubHeading>
          </Container>
        </Col>
        <Col xs={12} md={6} lg={6} style={{ textAlign: "center" }}>
          <img
            alt="Home Page Illustration"
            className="main-banner-illustration"
            src={Images.illustrationOne}
          />
        </Col>
      </Row>
    </MainBannerContainer>
  );
};

export default MainBanner;



// WEBPACK FOOTER //
// ./src/Containers/Home/MainBanner.tsx